var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(_vm.loadingContexts)?_c('splash-screen'):[_c('router-view'),_c('div',{staticClass:"about-drawer px-3 py-3",class:{ open: _vm.aboutOpen }},[_c('about')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }